import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

import { aspectRatio } from 'utils/styles.utils';

import { PageEventFragment } from 'types/api/dato-operations.types';

import DatoImage from 'components/@common/DatoImage';

interface Props {
  event: PageEventFragment;
  children?: ReactNode;
  childrenPosition?: 'before' | 'after';
}

const EventSideBarSticky = ({
  event,
  children,
  childrenPosition = 'after',
}: Props) => {
  return (
    <Stack
      sx={{
        gridArea: 'cover',
        position: 'sticky',
        top: 40,
        gap: 5,
        display: { xs: 'none', md: 'flex' },
        gridRowEnd: 'grid',
      }}
    >
      {childrenPosition === 'before' && children}
      <Box
        sx={{
          gridArea: 'cover',
          position: 'relative',
          borderRadius: 6,
          overflow: 'hidden',
          ...aspectRatio(1, 1),

          background:
            'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
        }}
      >
        <DatoImage
          data={event.cover}
          fill
          priority
          style={{ objectFit: 'cover' }}
          sizes="512px"
        />
      </Box>
      {childrenPosition === 'after' && children}
    </Stack>
  );
};

export default EventSideBarSticky;
